module.exports = __webpack_public_path__ + "static/media/rogersCredit1.0af3ee38.png";